import { useEffect, useRef, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	dealEventLogControllerGetUnreadQueryKey,
	dealEventLogControllerMarkViewedMutation,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { dealEventLogRequestOptions } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventLogUnread.ts';

export const useMarkDealEventLogViewed = (dealId: string) => {
	const queryClient = useQueryClient();
	const markedDealId = useRef<string | null>(null);
	const [previousViewedAt, setPreviousViewedAt] = useState<string>();

	const { mutateAsync } = useMutation({
		...dealEventLogControllerMarkViewedMutation(),
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: dealEventLogControllerGetUnreadQueryKey(
					dealEventLogRequestOptions(dealId)
				),
			});
		},
	});

	useEffect(() => {
		if (!dealId || markedDealId.current === dealId) {
			return;
		}
		markedDealId.current = dealId;
		void mutateAsync(dealEventLogRequestOptions(dealId)).then(
			(view) => setPreviousViewedAt(view.previousViewedAt),
			() => setPreviousViewedAt(undefined)
		);
	}, [dealId, mutateAsync]);

	return { previousViewedAt };
};
